import { render, staticRenderFns } from "./BotaoDashboardOperacoes.vue?vue&type=template&id=1400ebb0&lang=pug"
import script from "./BotaoDashboardOperacoes.vue?vue&type=script&lang=js"
export * from "./BotaoDashboardOperacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports